import { z } from "zod";
import { aiResultTargetSchema } from "./ai-tasks";

export const notificationKinds = [
  "ai-task-succeeded",
  "ai-task-failed",
] as const;
export const notificationKindSchema = z.enum(notificationKinds);
export type NotificationKindRuntime = z.infer<typeof notificationKindSchema>;

export const notificationEventKinds = [
  "notification-created",
  "notification-state-changed",
] as const;
export const notificationEventKindSchema = z.enum(notificationEventKinds);

const notificationIdSchema = z.string().uuid();
const notificationCursorSchema = z.string().trim().min(1).max(1024);
const isoTimestamp = z.string().datetime({ offset: true });

export const notificationItemSchema = z
  .object({
    id: notificationIdSchema,
    taskId: z.string().uuid(),
    kind: notificationKindSchema,
    title: z.string().trim().min(1).max(120),
    message: z.string().trim().min(1).max(500),
    target: aiResultTargetSchema.nullable(),
    createdAt: isoTimestamp,
    toastPresentedAt: isoTimestamp.nullable(),
    readAt: isoTimestamp.nullable(),
  })
  .strict();

export const notificationListQuerySchema = z
  .object({
    cursor: notificationCursorSchema.optional(),
    limit: z.coerce.number().int().min(1).max(100).default(20),
  })
  .strict();

export const notificationListResponseSchema = z
  .object({
    items: z.array(notificationItemSchema),
    nextCursor: notificationCursorSchema.nullable(),
    unreadCount: z.number().int().min(0),
    serverTime: isoTimestamp,
  })
  .strict();

export const toastClaimsBodySchema = z
  .object({
    limit: z.number().int().min(1).max(20),
    eligibleAfter: isoTimestamp,
  })
  .strict();

export const toastClaimsResponseSchema = z
  .object({
    items: z.array(notificationItemSchema),
    claimedAt: isoTimestamp,
  })
  .strict();

export const notificationReadResponseSchema = z
  .object({ id: notificationIdSchema, readAt: isoTimestamp })
  .strict();

export const notificationReadAllResponseSchema = z
  .object({ readAt: isoTimestamp, updatedCount: z.number().int().min(0) })
  .strict();

export type NotificationItemRuntime = z.infer<typeof notificationItemSchema>;
export type NotificationListResponseRuntime = z.infer<
  typeof notificationListResponseSchema
>;
export type ToastClaimsInputRuntime = z.infer<typeof toastClaimsBodySchema>;
export type ToastClaimsResponseRuntime = z.infer<
  typeof toastClaimsResponseSchema
>;
export type NotificationReadResponseRuntime = z.infer<
  typeof notificationReadResponseSchema
>;
export type NotificationReadAllResponseRuntime = z.infer<
  typeof notificationReadAllResponseSchema
>;
